import { useAppSelector } from '../store';
import { ChainThemeEnum } from '../store/api/restApi';
import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { checkTgApp, expandTgApp, hackViewPort, setBrowserPlatformClass } from '@/shared/lib';

export const TgProvider: FC<PropsWithChildren> = ({ children }) => {
  const [appReady, setAppReady] = useState(false);
  const theme = useAppSelector((state) => state.initial.settings.theme.name);

  useEffect(() => {
    const initializeApp = async () => {
      checkTgApp();
      await expandTgApp();
      setBrowserPlatformClass();
      await hackViewPort();
      setTimeout(() => setAppReady(true), 500);
    };

    initializeApp();
  }, []);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg && parseFloat(tg.version) >= 6.1) {
      if (theme === ChainThemeEnum.Light) tg.setHeaderColor('#ffffff');
    }
  }, [theme]);

  if (!appReady) return null;

  return <>{children}</>;
};
